import type {
  ApAgingBucket,
  ApAgingTotals as GeneratedApAgingTotals,
  InvoiceStatus,
  InvoiceType,
  SortingOrder,
} from "@/graphql/codegen/graphql"

// AK-6964 AC7: The user sorts the invoices of an expanded vendor on the screen; the backend only returns them ordered
// by due date.
export enum ApAgingInvoiceSortField {
  DaysOverdue = "DAYS_OVERDUE",
  DueDate = "DUE_DATE",
  Status = "STATUS",
}

export interface ApAgingInvoiceSort {
  field: ApAgingInvoiceSortField
  order: SortingOrder
}

// The generated type without its `__typename`, which the mapper drops.
export type ApAgingTotals = Omit<GeneratedApAgingTotals, "__typename">

export interface ApAgingInvoice {
  invoiceId: string
  invoiceNumber: string
  type: InvoiceType
  creationDate: string
  dueDate: string
  daysOverdue: number
  agingBucket: ApAgingBucket
  status: InvoiceStatus
  outstandingAmount: number
}

export interface ApAgingVendor {
  vendorCompanyId: string
  vendorName: string
  vendorNumber: string
  as400VendorNumber: string
  totals: ApAgingTotals
  invoices: ApAgingInvoice[]
}
